import { CaseVm, AttendanceVm } from './viewModel';
import { CaseInformation, AttendanceInformation } from '../../../models/api-client';
import { FormatterHelper } from '../../../common/utils/FormatterHelper';

const createCaseVm = (): CaseVm => ({
  caseDescriptionShort: '',
  createDate: '',
  caseGroup1: '',
  caStDescription: '',
  staffSignature: '',
  caseId: 0,
  caseClosed: '',
  attendance: [],
});

const mapCaseDtoToOpenCaseVm = (caseDto: CaseInformation): CaseVm => ({
  caseDescriptionShort: caseDto.caseDescriptionShort,
  createDate: FormatterHelper.germanDateFormatter(caseDto.createDate),
  caseGroup1: caseDto.caseGroup1,
  caStDescription: caseDto.caStClosesCase ? 'Temporär geschlossen' : caseDto.caStDescription,
  staffSignature: caseDto.staffSignature,
  staffShortName: caseDto.staffShortName,
  caseId: caseDto.caseId,
  recordId: caseDto.recordId,
  attendance: [] as AttendanceVm[],
  caseClosed: '',
});

const mapCaseDtoToCloseCaseVm = (caseDto: CaseInformation): CaseVm => ({
  caseDescriptionShort: caseDto.caseDescriptionShort,
  createDate: FormatterHelper.germanDateFormatter(caseDto.createDate),
  caseGroup1: caseDto.caseGroup1,
  caStDescription: caseDto.caStDescription,
  staffSignature: caseDto.staffSignature,
  staffShortName: caseDto.staffShortName,
  caseId: caseDto.caseId,
  recordId: caseDto.recordId,
  caseInvMarkDescription: caseDto.caseInvMarkDescription,
  caseClosed: FormatterHelper.germanDateFormatter(caseDto.caseClosed),
  attendance: [] as AttendanceVm[],
});

const mapAttendanceDtoToAttendanceVm = (attendanceDto: AttendanceInformation): AttendanceVm => ({
  staffSignature: attendanceDto.staffSignature,
  caTcDescription: attendanceDto.caTcDescription,
  caTcStart: FormatterHelper.extractHourToDate(attendanceDto.caTcStart),
  hour: FormatterHelper.extractDateToDate(attendanceDto.caTcStart),
  caTcEnd: FormatterHelper.extractDateToDate(attendanceDto.caTcEnd),
  caTcHours: attendanceDto.caTcHours,
  caTcHoursFree: attendanceDto.caTcHoursFree,
});

const mapCaseListDtoToCaseListOpenVm = (cases: CaseInformation[]): CaseVm[] => cases.map(mapCaseDtoToOpenCaseVm);

const mapCaseListDtoToCaseListCloseVm = (cases: CaseInformation[]): CaseVm[] => cases.map(mapCaseDtoToCloseCaseVm);

const mapAttendanceListDtoToAttendanceListVm = (attendances: AttendanceInformation[]): AttendanceVm[] => attendances.map(mapAttendanceDtoToAttendanceVm);

export default {
  createCaseVm,
  mapCaseDtoToOpenCaseVm,
  mapCaseDtoToCloseCaseVm,
  mapAttendanceDtoToAttendanceVm,
  mapCaseListDtoToCaseListOpenVm,
  mapCaseListDtoToCaseListCloseVm,
  mapAttendanceListDtoToAttendanceListVm,
};
